
import React from "react";

export const SupportIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className = "w-6 h-6 text-gray-100",
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M18.57 9.86248C18.57 14.7525 15.02 19.3325 10.17 20.6725C9.84001 20.7625 9.47999 20.7625 9.14999 20.6725C4.29999 19.3325 0.75 14.7525 0.75 9.86248V5.47247C0.75 4.65247 1.37001 3.72247 2.14001 3.41247L7.70999 1.1325C8.95999 0.6225 10.37 0.6225 11.62 1.1325L17.19 3.41247C17.95 3.72247 18.58 4.65247 18.58 5.47247L18.57 9.86248Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SupportV2Icon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className = "w-3 h-3 text-success",
  ...props
}) => {
  return (


    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}
      {...props}>
      <path d="M6 11C6 11 10 9 10 6V2.5L6 1L2 2.5V6C2 9 6 11 6 11Z" stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
};

